var React = require('react');

function Fundamentals (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.46,55 C40.95,55 52.55,44.86 56.03,32.50 C59.52,20.14 53.33,0 40.84,0 C28.34,0 0,3.87 0,22.56 C0,41.25 15.96,55 28.46,55 Z","id":"Oval","fill":"#FFF1D1","key":0}),React.createElement("g",{"id":"layers","transform":"translate(18.000000, 18.000000)","stroke":"#FF9429","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},[React.createElement("polygon",{"id":"Path","points":"10 0 0 5 10 10 20 5","key":0}),React.createElement("polyline",{"id":"Path","points":"0 15 10 20 20 15","key":1}),React.createElement("polyline",{"id":"Path","points":"0 10 10 15 20 10","key":2})])]);
}

Fundamentals.defaultProps = {"width":"57px","height":"55px","viewBox":"0 0 57 55","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = Fundamentals;

Fundamentals.default = Fundamentals;
